import { callExternalApi } from '../../callExternalApi';
import { Account } from '../../../types';

export async function getAccountById(id: string) {
  return await callExternalApi<Account>({
    url: `api/admin/accounts/${encodeURIComponent(id)}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
}
